export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10673.a41631f7.jpg";